import PropTypes from 'prop-types'
import { Button } from 'baseui/button'
import useDevTools from '@/containers/DevToolsNew/shared/useDevTools'
import SectionCard from '../shared/SectionCard'

import { FeedbackBadge, FooterActions, FooterRow, Table, Td, TheadRow, Th, TableWrap } from './styled-components'

const formatDateTime = value => (value ? new Date(value).toLocaleString() : '-')

const FeedbackTable = ({ rows, isLoading, error, pagination }) => {
  const { t } = useDevTools()

  const safeRows = Array.isArray(rows) ? rows : []
  const isEmpty = !isLoading && !error && safeRows.length === 0
  const hasRows = !isLoading && !error && safeRows.length > 0

  return (
    <SectionCard>
      <TableWrap>
        <Table>
          <thead>
            <TheadRow>
              <Th>{t('feedback.table.date')}</Th>
              <Th>{t('feedback.table.agent_firstname')}</Th>
              <Th>{t('feedback.table.agent_name')}</Th>
              <Th>{t('feedback.table.feedback_response')}</Th>
              <Th>{t('feedback.table.comment')}</Th>
              <Th>{t('feedback.table.subscriber_fullname')}</Th>
            </TheadRow>
          </thead>

          <tbody>
            {isLoading && (
              <tr>
                <Td colSpan={6}>{t('feedback.loading')}</Td>
              </tr>
            )}

            {error && (
              <tr>
                <Td colSpan={6}>{String(error)}</Td>
              </tr>
            )}

            {isEmpty && (
              <tr>
                <Td colSpan={6}>{t('feedback.no_result')}</Td>
              </tr>
            )}

            {hasRows &&
              safeRows.map(row => (
                <tr key={row.id}>
                  <Td>{formatDateTime(row.created_at)}</Td>
                  <Td>{row.agent_first_name || '-'}</Td>
                  <Td>{row.agent_name || '-'}</Td>
                  <Td>
                    <FeedbackBadge
                      $upvote={row.feedback === 1}
                      title={row.feedback === 1 ? t('feedback.upvote') : t('feedback.downvote')}
                    />
                  </Td>
                  <Td>{row.comment || '-'}</Td>
                  <Td>{`${row.firstname || ''} ${row.lastname || ''}`.trim() || '-'}</Td>
                </tr>
              ))}
          </tbody>
        </Table>
      </TableWrap>

      <FooterRow>
        <FooterActions>
          <Button
            size='compact'
            kind='secondary'
            disabled={!pagination.canGoPrevious}
            onClick={pagination.goPreviousPage}
          >
            {t('common.previous')}
          </Button>

          <Button
            size='compact'
            kind='secondary'
            disabled={!pagination.canGoNext}
            onClick={pagination.goNextPage}
          >
            {t('common.next')}
          </Button>
        </FooterActions>
      </FooterRow>
    </SectionCard>
  )
}

FeedbackTable.propTypes = {
  rows: PropTypes.array,
  isLoading: PropTypes.bool,
  error: PropTypes.any,
  pagination: PropTypes.shape({
    canGoPrevious: PropTypes.bool,
    canGoNext: PropTypes.bool,
    goPreviousPage: PropTypes.func,
    goNextPage: PropTypes.func,
  }),
}

export default FeedbackTable
